export const CopyOutlineIcon = ({ color = "#FFFFFF", size = 20, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#copy-outline-clip)">
      <path d="M15 1.66699H7.5C6.58333 1.66699 5.83333 2.41699 5.83333 3.33366V13.3337C5.83333 14.2503 6.58333 15.0003 7.5 15.0003H15C15.9167 15.0003 16.6667 14.2503 16.6667 13.3337V3.33366C16.6667 2.41699 15.9167 1.66699 15 1.66699ZM15 13.3337H7.5V3.33366H15V13.3337ZM2.5 12.5003V10.8337H4.16667V12.5003H2.5ZM2.5 7.91699H4.16667V9.58366H2.5V7.91699ZM8.33333 16.667H10V18.3337H8.33333V16.667ZM2.5 15.417V13.7503H4.16667V15.417H2.5ZM4.16667 18.3337C3.25 18.3337 2.5 17.5837 2.5 16.667H4.16667V18.3337ZM7.08333 18.3337H5.41667V16.667H7.08333V18.3337ZM11.25 18.3337V16.667H12.9167C12.9167 17.5837 12.1667 18.3337 11.25 18.3337ZM4.16667 5.00033V6.66699H2.5C2.5 5.75033 3.25 5.00033 4.16667 5.00033Z" fill={color} />
    </g>
    <defs>
      <clipPath id="copy-outline-clip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
